import React, { useState } from 'react'
import { intCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import styled from 'styled-components'
import CommonScreen from '../admin/component/CommonScreen'
import { connect } from 'react-redux'
import { Select, Button, InputNumber, Input } from 'antd'
import { Label } from 'core/screen-util'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { getUtilityNameMap, getUnitNameMap } from 'core/selectors'
import { monthsMap, months } from 'core/utils'
import {
  getVerificationLock,
  saveVerificationLock,
  deleteVerificationLock,
} from '../api/pgads'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'

const TableTD = styled.td`
  text-align: end;
`

const title = 'Verification Lock'

const VerificationLock = () => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <table
      style={{
        width: '100%',
        borderSpacing: '10px',
        borderCollapse: 'inherit',
      }}
    >
      <tbody>
        <tr>
          <td>
            <Label>Lock Name : </Label>
          </td>
          <td>
            <Input
              style={{ width: '200px' }}
              value={insertData.lockName}
              onChange={e =>
                setInsertData({ ...insertData, lockName: e.target.value })
              }
              maxLength={15}
            />
          </td>
          <TableTD>Start Summer Month :</TableTD>
          <td style={{ minWidth: '100px' }}>
            <Select
              onChange={month =>
                setInsertData({ ...insertData, lockoutStartsumMonth: month })
              }
              value={insertData.lockoutStartsumMonth}
              style={{ width: '100%' }}
            >
              {months.map((m, i) => (
                <Select.Option value={i + 1} key={i + 1}>
                  {m}
                </Select.Option>
              ))}
            </Select>
          </td>
          <TableTD>End Summer Month :</TableTD>
          <td style={{ minWidth: '100px' }}>
            <Select
              onChange={month =>
                setInsertData({ ...insertData, lockoutEndsumMonth: month })
              }
              value={insertData.lockoutEndsumMonth}
              style={{ width: '100%' }}
            >
              {months.map((m, i) => (
                <Select.Option value={i + 1} key={i + 1}>
                  {m}
                </Select.Option>
              ))}
            </Select>
          </td>
        </tr>
        <tr>
          <TableTD>Start Winter Month :</TableTD>
          <td style={{ width: '100px' }}>
            <Select
              onChange={month =>
                setInsertData({ ...insertData, lockoutStartswinMonth: month })
              }
              value={insertData.lockoutStartswinMonth}
              style={{ width: '100%' }}
            >
              {months.map((m, i) => (
                <Select.Option value={i + 1} key={i + 1}>
                  {m}
                </Select.Option>
              ))}
            </Select>
          </td>
          <TableTD>End Winter Month :</TableTD>
          <td style={{ minWidth: '100px' }}>
            <Select
              onChange={month =>
                setInsertData({ ...insertData, lockoutEndwinMonth: month })
              }
              value={insertData.lockoutEndwinMonth}
              style={{ width: '100%' }}
            >
              {months.map((m, i) => (
                <Select.Option value={i + 1} key={i + 1}>
                  {m}
                </Select.Option>
              ))}
            </Select>
          </td>
          <td>
            <Label>Lockout Days : </Label>
          </td>
          <td>
            <InputNumber
              style={{ width: '100px' }}
              defaultValue={0}
              onChange={value =>
                setInsertData({ ...insertData, lockoutDays: value })
              }
              min={0}
              value={insertData.lockOutDay}
            />
          </td>
          <td>
            <Button type="primary" onClick={() => onAdd(true)}>
              Add
            </Button>
          </td>
          <td>
            <Button type="primary" onClick={() => onAdd(false)}>
              Add & Hide
            </Button>
          </td>
          <td>
            <Button type="danger" onClick={onCancel}>
              Cancel
            </Button>
          </td>
        </tr>
      </tbody>
    </table>
  )

  return (
    <CommonScreen
      withUnitSelection={false}
      isAdminScreen
      title={title}
      header={VerificationLockHeaders}
      saveTask={saveVerificationLock}
      retrieveTask={getVerificationLock}
      deleteTask={deleteVerificationLock}
      altBy={d => d.unitId}
      autoRetrieve
      sortOptions={VerificationLockHeaders}
      widthOffset={100}
      heightOffset={270}
      insertComp={insertEvent && insertComp}
      onInsertEvent={b => setInsertEvent(b)}
      insertCompHeight={0}
      autoFixColByKey={false}
      headerRowHeight={60}
    />
  )
}

const mapStateToProps = state => ({
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(VerificationLock)

// eslint-disable-next-line no-unused-vars
const VerificationLockHeaders = [
  strCol({
    ident: 'lockName',
    display: 'Lock Name',
    isKey: true,
    sortOrder: 'asc',
    width: 200,
  }),
  numCol({
    ident: 'lockoutStartsumMonth',
    display: 'Start Summer Month',
    sortOrder: 'asc',
    ...toSelectionColProps(monthsMap),
    width: 200,
  }),
  numCol({
    ident: 'lockoutEndsumMonth',
    display: 'End Summer Month',
    sortOrder: 'asc',
    ...toSelectionColProps(monthsMap),
    width: 200,
  }),
  numCol({
    ident: 'lockoutStartswinMonth',
    display: 'Start Winter Month',
    sortOrder: 'asc',
    ...toSelectionColProps(monthsMap),
    width: 200,
  }),
  numCol({
    ident: 'lockoutEndwinMonth',
    display: 'End Winter Month',
    sortOrder: 'asc',
    ...toSelectionColProps(monthsMap),
    width: 200,
  }),
  intCol({
    ident: 'lockoutDays',
    display: 'Lockout Days',
    sortOrder: 'asc',
  }),
  modifierCol,
  modifiedDateCol,
]
